/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favdigitaltwin.vue?vue&type=template&id=5e3e4037&scoped=true"
import script from "./favdigitaltwin.vue?vue&type=script&lang=js"
export * from "./favdigitaltwin.vue?vue&type=script&lang=js"
import style0 from "./favdigitaltwin.vue?vue&type=style&index=0&id=5e3e4037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e4037",
  null
  
)

export default component.exports